import { useIsAuthenticated } from "hooks"
import { logout as newLogout } from "lib/api"
import { useRouter } from "lib/router"
import { navigateTo } from "@shared/utils.routing"
import { navigate } from "utils/routes"
import { loginWithRedirect } from "./utils/loginWithRedirect"

type useAuthContext = {
  isAuthenticated: boolean
  login: () => void
  loginURL: string
  logout: (redirectTo?: string) => Promise<void>
}

export const useAuth = (): useAuthContext => {
  const router = useRouter()
  const isAuthenticated = useIsAuthenticated()

  return {
    isAuthenticated,
    login: () => {
      if (!router.pathname.endsWith("/login")) {
        navigateTo(loginWithRedirect())
      } else {
        navigate()
      }
    },
    loginURL: loginWithRedirect(),
    logout: async (returnTo = "/") => {
      await newLogout()
      if (router.asPath === returnTo) {
        navigate() // reload
      } else {
        navigate(returnTo)
      }
    },
  }
}
